/**
 * requestPersistentStorage — asks the browser to mark our IndexedDB +
 * Cache Storage as "persistent" so it isn't evicted under storage pressure.
 * Silent best-effort; safe on browsers that don't support the API.
 */
export async function requestPersistentStorage() {
  try {
    if (typeof navigator === 'undefined' || !navigator.storage?.persist) return false;
    const already = await navigator.storage.persisted?.();
    if (already) return true;
    return await navigator.storage.persist();
  } catch { return false; }
}
